// Preserve the existing copy semantics while sharing one implementation.
export function deepCopyWithoutCircularRefs(obj) {
  const cache = new WeakSet();
  function copy(item) {
    if (typeof item !== 'object' || item === null) return item;
    if (cache.has(item)) return undefined;
    cache.add(item);
    const output = Array.isArray(item) ? [] : {};
    for (const key in item) output[key] = copy(item[key]);
    return output;
  }
  return copy(obj);
}

// Use for display-only arrays. Malformed permissions grant no access.
export function parseArray(value) {
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function numericRange(values, fallback = [0, 0]) {
  let min = Infinity;
  let max = -Infinity;
  for (const value of values) {
    if (value === '' || value == null) continue;
    const number = Number(value);
    if (!Number.isFinite(number)) continue;
    min = Math.min(min, number);
    max = Math.max(max, number);
  }
  return min === Infinity ? [...fallback] : [min, max];
}

export function tableToObjects(table) {
  if (!Array.isArray(table) || table.some((row) => !Array.isArray(row))) {
    throw new Error('Invalid statistics table');
  }
  const [headers = [], ...rows] = table;
  return {
    headers,
    rows: rows.map((row) => Object.fromEntries(headers.map((header, i) => [header, row[i] ?? '']))),
  };
}
